/** Sheets uploaded in this session are checked by the upload event, until the worker writes feedback. */
const UPLOAD_CLOCK_SLACK_MS = 120000;

/** @type {Map<string, number>} */
const sessionUploadStartedAt = new Map();

/** @type {Set<string>} */
const awaitingUploadFeedback = new Set();

/** @type {Set<string>} */
const claimedByWorker = new Set();

/**
 * @param {import("@seabrookstudios/types").GameId} gameId
 * @param {import("@seabrookstudios/pitch2table-core").AttachmentId} attachmentId
 */
const keyFor = (gameId, attachmentId) => `${gameId}:${attachmentId}`;

/**
 * @param {import("@seabrookstudios/types").GameId} gameId
 */
export const rememberSellSheetUpload = (gameId) => {
  if (!sessionUploadStartedAt.has(gameId)) {
    sessionUploadStartedAt.set(gameId, Date.now());
  }
};

/**
 * @param {import("@seabrookstudios/types").GameId} gameId
 * @param {Array<{ id: import("@seabrookstudios/pitch2table-core").AttachmentId, feedback?: string, uploadedTimestamp?: number }>} sellSheets
 */
export const noteSellSheetList = (gameId, sellSheets) => {
  const startedAt = sessionUploadStartedAt.get(gameId);

  sellSheets.forEach((sheet) => {
    const key = keyFor(gameId, sheet.id);
    if (sheet.feedback) {
      awaitingUploadFeedback.delete(key);
      claimedByWorker.add(key);
      return;
    }

    if (claimedByWorker.has(key) || !startedAt) {
      return;
    }

    if ((sheet.uploadedTimestamp || 0) >= startedAt - UPLOAD_CLOCK_SLACK_MS) {
      awaitingUploadFeedback.add(key);
    }
  });
};

/**
 * @param {import("@seabrookstudios/types").GameId} gameId
 * @param {import("@seabrookstudios/pitch2table-core").AttachmentId} attachmentId
 * @returns {boolean}
 */
export const shouldRequestSellSheetFeedback = (gameId, attachmentId) => {
  return !awaitingUploadFeedback.has(keyFor(gameId, attachmentId));
};
